(function videoModal() {
    var modal = document.querySelector(".confirmation-modal");
    if (modal) {
        var modalBackground_1 = document.querySelector(".modal-background");
        var modalClose_1 = document.querySelector(".modal-close");
        var btn = document.querySelector(".btn");
        var stickyHeader_1 = document.querySelector(".ac-ln-background");
        btn.addEventListener("click", function () {
            console.log("log");
            modal.classList.remove('hidden');
            modalBackground_1.classList.remove('hidden');
            modalClose_1.classList.remove('!hidden');
            stickyHeader_1.classList.add('hidden');
        });
        modalBackground_1.addEventListener("click", function () {
            console.log("hoho");
            modal.classList.add('hidden');
            modalBackground_1.classList.add('hidden');
        });
        modalClose_1.addEventListener("click", function () {
            console.log("yolo");
            modal.classList.add('hidden');
            modalBackground_1.classList.add('hidden');
            modalClose_1.classList.add('!hidden');
        });
    }
})();
